import React, { FC } from 'react'
import { Button, IconCaretRight, Divider, csx } from '@vtex/admin-ui'
import { injectIntl, FormattedMessage } from 'react-intl'
import { withMediaQuery } from '@/checkout-instore-legacy/utils/mediaQuery'

import ProductInformationModal from './ProductInformationModal'
import ProductInformationPage from './ProductInformationPage'

export type ProductContents = {
  name: string
  values: string[]
}

export type ProductInformationItemContents = string | ProductContents[]

interface ProductInformationItem {
  title: string
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
  contents: ProductInformationItemContents
}

interface ProductInformationProps {
  productInformation: ProductInformationItem[]
  mediaQuery: (options: {
    phone: boolean
    tablet: boolean
    desktop: boolean
  }) => boolean
}

const ProductInformation: FC<ProductInformationProps> = ({
  productInformation,
  mediaQuery,
}) => {
  const isMobile = mediaQuery({
    phone: true,
    tablet: false,
    desktop: false,
  })

  const handleOpen = (setIsOpen: (isOpen: boolean) => void) => {
    setIsOpen(true)
  }

  return (
    <div
      className={csx({
        paddingTop: '1.5rem',
      })}
    >
      <Divider />
      {productInformation.map((item) => {
        return (
          <div data-testid={`title-${item.title}`} key={item.title}>
            <div
              className={csx({
                display: 'flex',
                width: '100%',
                cursor: item.isOpen ? 'auto' : 'pointer',
                paddingTop: '.75rem',
                paddingBottom: '1rem',
              })}
              onMouseDown={() => handleOpen(item.setIsOpen)}
            >
              <div
                className={csx({
                  lineHeight: 1,
                  fontWeight: 400,
                  paddingTop: '.75rem',
                  display: 'flex',
                  flexDirection: 'column',
                  width: '90%',
                })}
              >
                <FormattedMessage id={item.title} />
              </div>
              <div
                className={csx({
                  width: '10%',
                  display: 'flex',
                  justifyItems: 'center',
                  justifyContent: 'center',
                })}
              >
                <Button
                  data-testid={`button-${item.title}`}
                  icon={<IconCaretRight title="information" />}
                  aria-label="information button"
                  variant="neutralTertiary"
                  onClick={() => handleOpen(item.setIsOpen)}
                />
              </div>
              {isMobile ? (
                <ProductInformationPage
                  // TODO: this error popped up when moving the checkout-instore project
                  // to checkout-instore-legacy, but needs to be fixed at some point
                  // @ts-ignore
                  titleId={item.title}
                  contents={item.contents}
                  type={typeof item.contents === 'string' ? 'text' : 'table'}
                  isOpen={item.isOpen}
                  setIsOpen={item.setIsOpen}
                />
              ) : (
                <ProductInformationModal
                  title={item.title}
                  aboutContents={item.contents}
                  isOpen={item.isOpen}
                  setIsOpen={item.setIsOpen}
                />
              )}
            </div>
            <Divider />
          </div>
        )
      })}
    </div>
  )
}

// TODO: this error popped up when moving the checkout-instore project
// to checkout-instore-legacy, but needs to be fixed at some point
// @ts-ignore
export default withMediaQuery(injectIntl(ProductInformation))
